<template>
  <div>
    <slot name="header"> </slot>

    <slot></slot>
  </div>
</template>

<script>
export default {
}
</script>
